/** Returns the URL only if it uses an http(s) scheme; otherwise "" — blocks
 * javascript:/data: DOM-XSS from untrusted scraped/LLM-provided URLs. */
export function safeHref(url: string | null | undefined): string {
  return url && /^https?:\/\//i.test(url) ? url : ""
}
